module.exports = __webpack_public_path__ + "static/media/11_tn.1ab710a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/11_tn.jpg
// module id = 441
// module chunks = 0